<app-header></app-header>
<main>
  <div class="appPopups">
    @if (!store.hasStarted()) {
      <app-rules></app-rules>
    } @else {
      <app-game></app-game>
    }
  </div>
</main>
<app-ar-scene></app-ar-scene>
<app-footer></app-footer>
